import Enum from "_define/Enum";

class Option {
    constructor() {
        this._apiPath = "/";
        this._contextPath = "/";
        this._resourcePath = "/";

        // token
        this._tokenKey = "itev";
        this._tokenEvaluatorKey = "itev_er";
        this._tokenEvaluateeKey = "itev_ee";

        // init 설정
        const _contextPathEl = document.getElementById("context-path");
        if (_contextPathEl) {
            const href = _contextPathEl.getAttribute("href");
            this._contextPath = href || "/";
            this._apiPath = href || "/";
            this._resourcePath = href || "/";

            if (href) {
                this._tokenKey = "itev" + "_" + href;
                this._tokenEvaluatorKey = "itev_er" + "_" + href;
                this._tokenEvaluateeKey = "itev_ee" + "_" + href;
            }

            window.option = this;
        }

        this._containerStyle = {
            maxWidth: 1920
        };

        this._domainPath = window.INTO_DOMAIN || `${window.location.protocol}//${window.location.host}${this._contextPath || "/"}`;
        this._pageUrlEvaluator = this._domainPath + "evaluator/signin"

        this.appAccessToken = null;
        this.appRefreshToken = null;
        this.evaluatorAccessToken = null;
        this.evaluatorRefreshToken = null;
        this.evaluateeAccessToken = null;
        this.evaluateeRefreshToken = null;
        this.isEnableLocalstorage = true;

        this._designerSettings = {
            enableTextFieldMaxLength: false
        };
    }

    get API_PATH() {
        return this._apiPath;
    }

    get CONTEXT_PATH() {
        return this._contextPath;
    }

    get RESOURCE_PATH() {
        return this._resourcePath;
    }

    get PAGE_URL_EVALUATOR() {
        return this._pageUrlEvaluator;
    }

    get DESIGNER_SETTINGS() {
        const settings = {...this._designerSettings};

        if(window.INTO_DESIGN_SETTINGS){
            if(window.INTO_DESIGN_SETTINGS['enableTextFieldMaxLength'] === true){
                settings['enableTextFieldMaxLength'] = true
            }
        }
        return settings;
    }

    get TOKEN_KEY() {
        return this._tokenKey;
    }

    get TOKEN_KEY_EVALUATOR() {
        return this._tokenEvaluatorKey;
    }

    get TOKEN_KEY_EVALUATEE() {
        return this._tokenEvaluateeKey;
    }

    get SSE_API() {
        return `/v1/sse/workspace/{0}?domains=EVALUATION&domains=EVALUATOR&domains=EVALUATEE`;
    }

    get REST_API() {
        return {
            USER: {
                MINE: {
                    METHOD: Enum.FE_HTTP_METHOD.GET,
                    TOKEN: Enum.FE_TOKEN_TYPE.APP,
                    AUTHORIZATION: null,
                    URL: `${this.REST_API_URL.API.USER}/${this.REST_API_ACTION.MINE}`,
                    ERROR_CODE: [],
                },

                INFO_MINE: {
                    METHOD: Enum.FE_HTTP_METHOD.GET,
                    TOKEN: Enum.FE_TOKEN_TYPE.APP,
                    AUTHORIZATION: null,
                    URL: `${this.REST_API_URL.API.USER}/${this.REST_API_ACTION.MINE}`,
                    ERROR_CODE: [],
                },
                UPDATE_MINE: {
                    METHOD: Enum.FE_HTTP_METHOD.POST,
                    TOKEN: Enum.FE_TOKEN_TYPE.APP,
                    AUTHORIZATION: null,
                    URL: `${this.REST_API_URL.API.USER}/mine/${this.REST_API_ACTION.UPDATE}`,
                    ERROR_CODE: [],
                }
            },
            USER_TOKEN: {
                CREATE: {
                    METHOD: Enum.FE_HTTP_METHOD.POST,
                    TOKEN: Enum.FE_TOKEN_TYPE.APP,
                    AUTHORIZATION: null,
                    URL: `${this.REST_API_URL.API.USER_TOKEN}/${this.REST_API_ACTION.CREATE}`,
                    REQUIRE: ["email", "password"],
                    ERROR_CODE: [],
                },
                DELETE: {
                    METHOD: Enum.FE_HTTP_METHOD.POST,
                    TOKEN: Enum.FE_TOKEN_TYPE.APP,
                    AUTHORIZATION: null,
                    URL: `${this.REST_API_URL.API.USER_TOKEN}/${this.REST_API_ACTION.DELETE}`,
                    ERROR_CODE: [],
                },
            },
            WORKSPACE: {
                BASE: {
                    LIST_MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/mine/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                MEMBER: {
                    MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.MEMBER}/${this.REST_API_ACTION.MINE}`,
                        ERROR_CODE: [],
                    },

                    // cat. mine
                    INFO_MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/member/${this.REST_API_ACTION.MINE}`,
                        ERROR_CODE: [],
                    },
                    UPDATE_MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.MEMBER}/mine/${this.REST_API_ACTION.UPDATE}`,
                        ERROR_CODE: ["name"],
                    },
                },
                ORGANIZATION: {
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.ORGANIZATION}/{1}`,
                        ERROR_CODE: [],
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.ORGANIZATION}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                    },
                    SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.ORGANIZATION}/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: [],
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_ORGANIZATION}/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["name", "email"],
                        ERROR_CODE: [],
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_ORGANIZATION}/{1}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: ["name", "email"],
                        ERROR_CODE: []
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_ORGANIZATION}/{1}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BFF_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_ORGANIZATION}/bff/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["name", "email"],
                        ERROR_CODE: [],
                    },
                    BFF_BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_ORGANIZATION}/bff/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: ["name", "email"],
                        ERROR_CODE: [],
                    },
                    BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_ORGANIZATION}/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: ["name", "email"],
                        ERROR_CODE: [],
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_ORGANIZATION}/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATOR_POOL: {
                    COUNT: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATOR_POOL}/${this.REST_API_ACTION.COUNT}`,
                        ERROR_CODE: [],
                    },
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATOR_POOL}/{1}`,
                        ERROR_CODE: [],
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATOR_POOL}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                    },
                    SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATOR_POOL}/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: [],
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATOR_POOL}/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["type", "name", "email", "phone"],
                        ERROR_CODE: [],
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATOR_POOL}/{1}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: ["name", "email", "phone"],
                        ERROR_CODE: []
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATOR_POOL}/{1}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATOR_POOL}/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: ["type", "name", "email", "phone"],
                        ERROR_CODE: [],
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATOR_POOL}/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },


                    ADMIN_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATOR_POOL}/{1}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: ["name", "email", "phone"],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_TEMPLATE: {
                    COUNT: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE}/${this.REST_API_ACTION.COUNT}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },

                    COPY: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE}/{1}/${this.REST_API_ACTION.COPY}`,
                        REQUIRE: ["name"],
                        ERROR_CODE: [],
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE}/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["code", "name"],
                        ERROR_CODE: []
                    },

                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE}/{1}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BFF_UPLOAD: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE}/bff/${this.REST_API_ACTION.UPLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_DOWNLOAD: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE}/bff/{1}/${this.REST_API_ACTION.DOWNLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE_EVALUATION: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: this.API_PATH + "v1/internal/workspace/{0}/custom-evaluation-template/{1}/evaluation/create",
                        //URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["code", "name"],
                        ERROR_CODE: [],
                    },


                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: [],
                    },
                    ADMIN_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_TEMPLATE_CATEGORY: {
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_CATEGORY}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_CATEGORY}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },


                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-category/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-category/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-category/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-category/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-category/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_TEMPLATE_DATA: {
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_DATA}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_DATA}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },

                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-data/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-data/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-data/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-data/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_TEMPLATE_PARTICIPANT: {
                    BFF_LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE_PARTICIPANT}/bff/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE_PARTICIPANT}/bff/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ['name', 'file'],
                        ERROR_CODE: [],
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_PARTICIPANT}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE_PARTICIPANT}/bff/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_PARTICIPANT}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },


                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-participant/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-participant/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-participant/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-participant/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-participant/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_TEMPLATE_DOCUMENT: {
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE_DOCUMENT}/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE_DOCUMENT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },

                    BFF_LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE_DOCUMENT}/bff/type/{2}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPDATE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_DOCUMENT}/{2}/file/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_DOCUMENT}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_DOCUMENT}/bff/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.ADMIN_EVALUATION_TEMPLATE_DOCUMENT}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    DOWNLOAD_RESOURCE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_TEMPLATE_DOCUMENT}/{2}/resource-file/download`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },


                    LIST_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-document/type/{2}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-document/file/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ['name', 'file'],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-document/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-document/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BFF_LIST_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation-template/{1}/evaluation-template-document/bff/type/{2}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_CREATE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-document/bff/file/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ['name', 'file'],
                        ERROR_CODE: [],
                    },
                    BFF_COPY: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-document/bff/{2}/${this.REST_API_ACTION.COPY}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/admin/evaluation-template/{1}/evaluation-template-document/bff/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },

                EVALUATION: {
                    COUNT: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/${this.REST_API_ACTION.COUNT}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    STATISTIC: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/${this.REST_API_ACTION.STATISTIC}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: [],
                    },

                    UPDATE_STATUS: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/{1}/status/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/{1}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    DOWNLOAD_MEDIA_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/{1}/media-file/{2}/${this.REST_API_ACTION.DOWNLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    ASYNC_GATHER: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/{1}/async-gather`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    ASYNC_CONVERT: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/{1}/async-convert`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    INFO_GATHERING_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION}/{1}/evaluation-gathering`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },


                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["code", "name"],
                        ERROR_CODE: [],
                    },
                    CREATE_TEMPLATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/custom-evaluation-template/{1}/evaluation/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["code", "name"],
                        ERROR_CODE: [],
                    },
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_CATEGORY: {
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_CATEGORY}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_CATEGORY}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },


                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-category/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-category/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-category/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-category/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-category/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_CATEGORY_REFERENCE: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_CATEGORY_REFERENCE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_DATA: {
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DATA}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DATA}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },


                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-data/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-data/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-data/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-data/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_PARTICIPANT: {
                    BFF_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_PARTICIPANT}/bff/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_PARTICIPANT}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_PARTICIPANT}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },


                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BFF_LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/bff/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/bff/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/participant/bff/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                },
                EVALUATION_DOCUMENT: {
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    UPDATE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/{2}/file/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BFF_LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/bff/type/{2}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/bff/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DOWNLOAD_RESOURCE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/{2}/resource-file/download`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DOWNLOAD_RESOURCE_FILES: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_DOCUMENT}/resource-file/download`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },


                    LIST_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/type/{2}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/file/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ['name', 'file'],
                        ERROR_CODE: [],
                    },
                    BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                    BFF_LIST_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/bff/type/{2}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_CREATE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/bff/file/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ['name', 'file'],
                        ERROR_CODE: [],
                    },
                    BFF_COPY: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/bff/{2}/${this.REST_API_ACTION.COPY}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_BATCH_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: [Enum.MEMBER_ROLE.ADMIN],
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluation-document/bff/${this.REST_API_ACTION.BATCH_UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_EVALUATOR: {
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_INPUT_DATA_DOCUMENT_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/{2}/evaluation-document/type/{3}/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATOR_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/{2}/evaluation-document/type/{3}/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_EVALUATORS_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/evaluation-document/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATORS_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/evaluation-document/type/{2}/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPDATE_COMPLETED: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/{2}/completed/${this.REST_API_ACTION.UPDATE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/bff/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/bff/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/bff/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },

                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluator/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluator/bff/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR}/bff/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                },
                EVALUATION_EVALUATOR_PARTICIPANT: {
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_PARTICIPANT}/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["evaluatorId", "participantId"],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_PARTICIPANT}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_PARTICIPANT}/${this.REST_API_ACTION.BATCH_MERGE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_MERGE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_PARTICIPANT}/${this.REST_API_ACTION.BATCH_MERGE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },

                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.BASE}/{0}/evaluation/{1}/evaluator-participant/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_PARTICIPANT}/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                },
                EVALUATION_EVALUATOR_DOCUMENT: {
                    LIST_TYPE_EVALUATOR_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_DOCUMENT}/type/{2}/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_EVALUATEE: {
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_INPUT_DATA_DOCUMENT_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/{2}/evaluation-document/type/{3}/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATEE_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/{2}/evaluation-document/type/{3}/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_EVALUATEES_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/evaluation-document/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATEES_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/evaluation-document/type/{2}/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    UPDATE_COMPLETED: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/{2}/completed/${this.REST_API_ACTION.UPDATE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/bff/{2}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/bff/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/bff/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/bff/{2}/${this.REST_API_ACTION.UPDATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BFF_BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE}/bff/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                },
                EVALUATION_EVALUATEE_PARTICIPANT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE_PARTICIPANT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE_PARTICIPANT}/${this.REST_API_ACTION.CREATE}`,
                        REQUIRE: ["evaluatorId", "participantId"],
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE_PARTICIPANT}/{2}/${this.REST_API_ACTION.DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },

                    BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE_PARTICIPANT}/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE_PARTICIPANT}/${this.REST_API_ACTION.BATCH_MERGE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_MERGE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE_PARTICIPANT}/${this.REST_API_ACTION.BATCH_MERGE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },

                },
                EVALUATION_EVALUATEE_DOCUMENT: {
                    LIST_TYPE_EVALUATOR_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATEE_DOCUMENT}/type/{2}/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_EVALUATOR_QUESTION_SELECT_DATA: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_QUESTION_SELECT_DATA}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BATCH_CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_QUESTION_SELECT_DATA}/${this.REST_API_ACTION.BATCH_CREATE}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    BATCH_DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_EVALUATOR_QUESTION_SELECT_DATA}/${this.REST_API_ACTION.BATCH_DELETE}`,
                        REQUIRE: [],
                        ERROR_CODE: []
                    },
                },
                EVALUATION_OUTPUT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_OUTPUT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DOWNLOAD: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_OUTPUT}/{2}/${this.REST_API_ACTION.DOWNLOAD}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    },
                    DOWNLOAD_ARCHIVE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.APP,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.WORKSPACE.EVALUATION_OUTPUT}/type/archive/${this.REST_API_ACTION.DOWNLOAD}`,
                        REQUIRE: [],
                        ERROR_CODE: [],
                    }
                }
            },
            EVALUATOR: {
                WORKSPACE: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.WORKSPACE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                    }
                },
                EVALUATOR_POOL: {
                    MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_POOL}/mine`,
                    },
                    MINE_UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_POOL}/mine/${this.REST_API_ACTION.UPDATE}`,
                    },
                },

                EVALUATOR_POOL_TOKEN: {
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_POOL_TOKEN}/${this.REST_API_ACTION.CREATE}`,
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_POOL_TOKEN}/${this.REST_API_ACTION.DELETE}`,
                        ERROR_CODE: [],
                    }
                },
                EVALUATION: {
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/{0}`,
                        ERROR_CODE: []
                    },
                    INFO_MINIMAL: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/{0}/${this.REST_API_ACTION.MINIMAL}`,
                        ERROR_CODE: []
                    },
                    SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: []
                    },
                    BFF_INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/bff/{0}`,
                        ERROR_CODE: []
                    },
                    BFF_SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/bff/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: []
                    },
                    DOWNLOAD_MEDIA_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/{0}/media-file/{1}/${this.REST_API_ACTION.DOWNLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPLOAD_MEDIA_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/{0}/media-file/${this.REST_API_ACTION.UPLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    INFO_GATHERING_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/{0}/evaluation-gathering`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },

                    UPDATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATOR_EVALUATION}/{0}/${this.REST_API_ACTION.UPDATE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_CATEGORY: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_CATEGORY}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_CATEGORY_REFERENCE: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_CATEGORY_REFERENCE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_DATA: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_DATA}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_PARTICIPANT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_PARTICIPANT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_DOCUMENT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_DOCUMENT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_DOCUMENT}/type/{1}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DOWNLOAD_RESOURCE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_DOCUMENT}/{1}/resource-file/download`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE_EVALUATOR_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_DOCUMENT}/{1}/evaluator-data/${this.REST_API_ACTION.CREATE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_EVALUATOR: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_EVALUATORS_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/evaluation-document/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATOR_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/{1}/evaluation-document/type/{2}/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATORS_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/evaluation-document/type/{1}/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    INFO_MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/${this.REST_API_ACTION.MINE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_INFO_MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/bff/${this.REST_API_ACTION.MINE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPLOAD_SIGNATURE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/signature-file/${this.REST_API_ACTION.UPLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DOWNLOAD_SIGNATURE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/signature-file/${this.REST_API_ACTION.DOWNLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPDATE_COMPLETED: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR}/completed/${this.REST_API_ACTION.UPDATE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_EVALUATEE: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATEE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATEES_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATEE}/evaluation-document/type/{1}/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_EVALUATOR_PARTICIPANT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATOR_PARTICIPANT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_EVALUATEE_PARTICIPANT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATOR,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATOR.EVALUATION_EVALUATEE_PARTICIPANT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
            },
            EVALUATEE: {
                WORKSPACE: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.WORKSPACE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                    }
                },
                EVALUATEE_POOL: {
                    MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_POOL}/${this.REST_API_ACTION.MINE}`,
                        ERROR_CODE: [],
                    }
                },
                EVALUATEE_POOL_TOKEN: {
                    CREATE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_POOL_TOKEN}/${this.REST_API_ACTION.CREATE}`,
                        ERROR_CODE: [],
                    },
                    DELETE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_POOL_TOKEN}/${this.REST_API_ACTION.DELETE}`,
                        ERROR_CODE: [],
                    }
                },
                EVALUATION: {
                    INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/{0}`,
                        ERROR_CODE: []
                    },
                    INFO_MINIMAL: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/{0}/${this.REST_API_ACTION.MINIMAL}`,
                        ERROR_CODE: []
                    },
                    SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: []
                    },
                    BFF_INFO: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/bff/{0}`,
                        ERROR_CODE: []
                    },
                    BFF_SEARCH: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/bff/${this.REST_API_ACTION.SEARCH}`,
                        ERROR_CODE: []
                    },
                    DOWNLOAD_MEDIA_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/{0}/media-file/{1}/${this.REST_API_ACTION.DOWNLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPLOAD_MEDIA_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/{0}/media-file/${this.REST_API_ACTION.UPLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    INFO_GATHERING_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/{0}/evaluation-gathering`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_CATEGORY: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_CATEGORY}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_CATEGORY_REFERENCE: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_CATEGORY_REFERENCE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_DATA: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_DATA}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_PARTICIPANT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_PARTICIPANT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_DOCUMENT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_DOCUMENT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_TYPE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_DOCUMENT}/type/{1}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DOWNLOAD_RESOURCE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_DOCUMENT}/{1}/resource-file/download`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    CREATE_EVALUATEE_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_DOCUMENT}/{1}/evaluatee-data/${this.REST_API_ACTION.CREATE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_EVALUATEE: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_EVALUATEES_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/evaluation-document/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATEE_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/{1}/evaluation-document/type/{2}/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATEES_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/evaluation-document/type/{1}/evaluatee-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    INFO_MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/${this.REST_API_ACTION.MINE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    BFF_INFO_MINE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/bff/${this.REST_API_ACTION.MINE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPLOAD_SIGNATURE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATEE_EVALUATION}/signature-file/${this.REST_API_ACTION.UPLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    DOWNLOAD_SIGNATURE_FILE: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/signature-file/${this.REST_API_ACTION.DOWNLOAD}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    UPDATE_COMPLETED: {
                        METHOD: Enum.FE_HTTP_METHOD.POST,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE}/completed/${this.REST_API_ACTION.UPDATE}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_EVALUATOR: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATOR}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                    LIST_EVALUATION_DOCUMENT_TYPE_EVALUATORS_DATA: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATOR}/evaluation-document/type/{1}/evaluator-data/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
                EVALUATION_EVALUATOR_PARTICIPANT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATOR_PARTICIPANT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    }
                },
                EVALUATION_EVALUATEE_PARTICIPANT: {
                    LIST: {
                        METHOD: Enum.FE_HTTP_METHOD.GET,
                        TOKEN: Enum.FE_TOKEN_TYPE.EVALUATEE,
                        AUTHORIZATION: null,
                        URL: `${this.REST_API_URL.API.EVALUATEE.EVALUATION_EVALUATEE_PARTICIPANT}/${this.REST_API_ACTION.LIST}`,
                        ERROR_CODE: [],
                        PARAMS: {}
                    },
                },
            },
        }
    }

    get REST_API_URL() {
        return {
            "API": {
                USER: this.API_PATH + "v1/internal/user",
                USER_TOKEN: this.API_PATH + "v1/internal/user-token",
                WORKSPACE: {
                    BASE: this.API_PATH + "v1/internal/workspace",
                    MEMBER: this.API_PATH + "v1/internal/workspace/{0}/member",
                    ORGANIZATION: this.API_PATH + "v1/internal/workspace/{0}/member",
                    EVALUATOR_POOL: this.API_PATH + "v1/internal/workspace/{0}/people",
                    EVALUATEE_POOL: this.API_PATH + "v1/internal/workspace/{0}/evaluatee-pool",
                    ADMIN_ORGANIZATION: this.API_PATH + "v1/internal/workspace/{0}/admin/member",
                    ADMIN_EVALUATOR_POOL: this.API_PATH + "v1/internal/workspace/{0}/admin/people",
                    ADMIN_EVALUATEE_POOL: this.API_PATH + "v1/internal/workspace/{0}/admin/evaluatee-pool",

                    EVALUATION_TEMPLATE: this.API_PATH + "v1/internal/workspace/{0}/evaluation-template",
                    EVALUATION_TEMPLATE_CATEGORY: this.API_PATH + "v1/internal/workspace/{0}/evaluation-template/{1}/evaluation-template-category",
                    EVALUATION_TEMPLATE_DATA: this.API_PATH + "v1/internal/workspace/{0}/evaluation-template/{1}/evaluation-template-data",
                    EVALUATION_TEMPLATE_PARTICIPANT: this.API_PATH + "v1/internal/workspace/{0}/evaluation-template/{1}/evaluation-template-participant",
                    EVALUATION_TEMPLATE_DOCUMENT: this.API_PATH + "v1/internal/workspace/{0}/evaluation-template/{1}/evaluation-template-document",

                    ADMIN_EVALUATION_TEMPLATE: this.API_PATH + "v1/internal/workspace/{0}/admin/evaluation-template",
                    ADMIN_EVALUATION_TEMPLATE_DATA: this.API_PATH + "v1/internal/workspace/{0}/admin/evaluation-template/{1}/evaluation-template-data",
                    ADMIN_EVALUATION_TEMPLATE_CATEGORY: this.API_PATH + "v1/internal/workspace/{0}/admin/evaluation-template/{1}/evaluation-template-category",
                    ADMIN_EVALUATION_TEMPLATE_PARTICIPANT: this.API_PATH + "v1/internal/workspace/{0}/admin/evaluation-template/{1}/evaluation-template-participant",
                    ADMIN_EVALUATION_TEMPLATE_DOCUMENT: this.API_PATH + "v1/internal/workspace/{0}/admin/evaluation-template/{1}/evaluation-template-document",

                    EVALUATION: this.API_PATH + "v1/internal/workspace/{0}/evaluation",
                    EVALUATION_CATEGORY: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluation-category",
                    EVALUATION_CATEGORY_REFERENCE: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluation-category-reference",
                    EVALUATION_DATA: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluation-data",
                    EVALUATION_PARTICIPANT: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/participant",
                    EVALUATION_DOCUMENT: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluation-document",
                    EVALUATION_EVALUATOR: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluator",
                    EVALUATION_EVALUATOR_PARTICIPANT: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluator-participant",
                    EVALUATION_EVALUATOR_DOCUMENT: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluator/evaluation-document",
                    EVALUATION_EVALUATOR_QUESTION_SELECT_DATA: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluator_question_select_data",

                    EVALUATION_EVALUATEE: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluatee",
                    EVALUATION_EVALUATEE_PARTICIPANT: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluatee-participant",
                    EVALUATION_EVALUATEE_DOCUMENT: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluatee/evaluation-document",

                    EVALUATION_OUTPUT: this.API_PATH + "v1/internal/workspace/{0}/evaluation/{1}/evaluation-output",
                },
                EVALUATEE: {
                    WORKSPACE: this.API_PATH + "v1/evaluatee/workspace",
                    EVALUATEE_POOL: this.API_PATH + "v1/evaluatee/evaluatee-pool",
                    EVALUATEE_POOL_TOKEN: this.API_PATH + "v1/evaluatee/evaluatee-pool-token",
                    EVALUATEE_EVALUATION: this.API_PATH + "v1/evaluatee/evaluation",

                    EVALUATION: this.API_PATH + "v1/evaluatee/evaluation",
                    EVALUATION_CATEGORY: this.API_PATH + "v1/evaluatee/evaluation/{0}/evaluation-category",
                    EVALUATION_DATA: this.API_PATH + "v1/evaluatee/evaluation/{0}/evaluation-data",
                    EVALUATION_PARTICIPANT: this.API_PATH + "v1/evaluatee/evaluation/{0}/participant",
                    EVALUATION_DOCUMENT: this.API_PATH + "v1/evaluatee/evaluation/{0}/evaluation-document",
                    EVALUATION_EVALUATOR: this.API_PATH + "v1/evaluatee/evaluation/{0}/evaluator",
                    EVALUATION_EVALUATEE: this.API_PATH + "v1/evaluatee/evaluation/{0}/evaluatee",
                    EVALUATION_EVALUATOR_PARTICIPANT: this.API_PATH + "v1/evaluatee/evaluation/{0}/evaluator-participant",
                    EVALUATION_EVALUATEE_PARTICIPANT: this.API_PATH + "v1/evaluatee/evaluation/{0}/evaluatee-participant",
                },
                EVALUATOR: {
                    WORKSPACE: this.API_PATH + "v1/evaluator/workspace",
                    EVALUATOR_POOL: this.API_PATH + "v1/evaluator/people",
                    EVALUATOR_POOL_TOKEN: this.API_PATH + "v1/evaluator/people-token",
                    EVALUATOR_EVALUATION: this.API_PATH + "v1/evaluator/evaluation",


                    EVALUATION: this.API_PATH + "v1/evaluator/evaluation",
                    EVALUATION_CATEGORY: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluation-category",
                    EVALUATION_CATEGORY_REFERENCE: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluation-category-reference",
                    EVALUATION_DATA: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluation-data",
                    EVALUATION_PARTICIPANT: this.API_PATH + "v1/evaluator/evaluation/{0}/participant",
                    EVALUATION_DOCUMENT: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluation-document",
                    EVALUATION_EVALUATOR: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluator",
                    EVALUATION_EVALUATEE: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluatee",
                    EVALUATION_EVALUATOR_PARTICIPANT: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluator-participant",
                    EVALUATION_EVALUATEE_PARTICIPANT: this.API_PATH + "v1/evaluator/evaluation/{0}/evaluatee-participant",

                }
            },
        }
    }

    get REST_API_ACTION() {
        return {
            LIST: "list",
            SEARCH: "search",

            COPY: "copy",
            CREATE: "create",
            UPDATE: "update",
            DELETE: "delete",
            BATCH_CREATE: "batch-create",
            BATCH_UPDATE: "batch-update",
            BATCH_DELETE: "batch-delete",
            BATCH_MERGE: "batch-merge",


            // default
            MINE: "mine",
            TYPE: "type",
            STATUS: "status",


            COUNT: "count",
            UPLOAD: "upload",
            DOWNLOAD: "download",
            STATISTIC: "statistic",


            // evaluation
            MINIMAL: "minimal",


            FILE_UPDATE: "file/update",


            RESOURCE_FILE_DOWNLOAD: "resource-file/download",


            RESOURCE_FILE: "resource-file",
            MEDIA_FILE: "media-file",
            EVALUATION_DOCUMENT: "evaluation-document",
            EVALUATOR_DATA: "evaluator-data",
        }
    };

    // cat. route
    get ROUTE_PATH() {
        return {
            SIGN_IN: this.CONTEXT_PATH + "signin",

            // 사용자
            MENU_MEMBER: this.CONTEXT_PATH + "member",
            MENU_EVALUATION: this.CONTEXT_PATH + "evaluation",
            MENU_EVALUATION_OPEN: this.CONTEXT_PATH + "evaluation/OPEN",
            MENU_EVALUATION_CLOSE: this.CONTEXT_PATH + "evaluation/CLOSE",

            // 관리자
            MENU_DASHBOARD: this.CONTEXT_PATH + "admin/dashboard",
            MENU_ORGANIZATION: this.CONTEXT_PATH + "admin/organization",
            MENU_EVALUATOR: this.CONTEXT_PATH + "admin/evaluator",
            MENU_EVALUATEE: this.CONTEXT_PATH + "admin/evaluatee",
            MENU_TEMPLATE: this.CONTEXT_PATH + "admin/template",

            // 상세
            DETAIL_EVALUATION_TEMPLATE: this.CONTEXT_PATH + "detail/template",
            DESIGN_EVALUATION_TEMPLATE: this.CONTEXT_PATH + "edit/template",

            DETAIL_READY_EVALUATION: this.CONTEXT_PATH + "ready/evaluation",
            DETAIL_OPEN_EVALUATION: this.CONTEXT_PATH + "open/evaluation",
            DETAIL_CLOSE_EVALUATION: this.CONTEXT_PATH + "detail/evaluation",
            DESIGN_EVALUATION: this.CONTEXT_PATH + "edit",

            // 평가자
            EVALUATOR: this.CONTEXT_PATH + "evaluator",
            EVALUATOR_DOC: this.CONTEXT_PATH + "evaluator/document",
            EVALUATOR_LEADER_DATA: this.CONTEXT_PATH + "evaluator/leader-data",
            EVALUATOR_SIGN_IN: this.CONTEXT_PATH + "evaluator/signin",

            // 피평가자
            EVALUATEE: this.CONTEXT_PATH + "evaluatee",
            EVALUATEE_DOC: this.CONTEXT_PATH + "evaluatee/document",
            EVALUATEE_SIGN_IN: this.CONTEXT_PATH + "evaluatee/signin",
        };
    };

    // cat. resource
    get INTO_IMG() {
        return {
            CUSTOMER: {
                LOGO: this.CONTEXT_PATH + "images/customer/CI_Logo.jpg",
                SYMBOL: this.CONTEXT_PATH + "images/customer/CI_Symbol.png",
                BRAND: this.CONTEXT_PATH + "images/customer/brand.jpg",
                BG: this.CONTEXT_PATH + "images/customer/bg.jpg",
                INFO_BG: this.CONTEXT_PATH + "images/customer/info_bg.png",
                INFO_STOCK: this.CONTEXT_PATH + "images/customer/info_stock.svg",
            },
            LOGO: this.CONTEXT_PATH + "images/logo.png",
            LOGO_MOBILE: this.CONTEXT_PATH + "images/logo_mobile.png",
            POINTER: this.CONTEXT_PATH + "images/pointer/pointer.svg"
        }
    };

    get INTO_ASSET_ICON() {
        const image = {
            ERROR: this.RESOURCE_PATH + "images/asset/error.svg",
            STOCK: this.RESOURCE_PATH + "images/asset/stock.svg",

            NOTIFY_ERROR: this.RESOURCE_PATH + "images/asset/notify/error.svg",
            NOTIFY_SPEAKER: this.RESOURCE_PATH + "images/asset/notify/speaker.svg",
            NOTIFY_SUCCESS: this.RESOURCE_PATH + "images/asset/notify/success.svg",
            NOTIFY_WARNING: this.RESOURCE_PATH + "images/asset/notify/warning.svg",

            // cat. menu
            MENU_MEMBER: this.RESOURCE_PATH + "images/asset/menu_member.svg",
            MENU_DASHBOARD: this.RESOURCE_PATH + "images/asset/menu_dashboard.svg",
            MENU_ORGANIZATION: this.RESOURCE_PATH + "images/asset/menu_organization.svg",
            MENU_EVALUATOR: this.RESOURCE_PATH + "images/asset/menu_people.svg",
            MENU_EVALUATEE: this.RESOURCE_PATH + "images/asset/menu_evaluatee.svg",
            MENU_TEMPLATE: this.RESOURCE_PATH + "images/asset/menu_template.svg",
            MENU_EVALUATION: this.RESOURCE_PATH + "images/asset/menu_evaluation_ready.svg",
            MENU_EVALUATION_OPEN: this.RESOURCE_PATH + "images/asset/menu_evaluation_open.svg",
            MENU_EVALUATION_CLOSE: this.RESOURCE_PATH + "images/asset/menu_evaluation_close.svg",

            EVALUATION_MENU_INFO: this.RESOURCE_PATH + "images/asset/evaluation_menu_info.svg",
            EVALUATION_MENU_INFO_CATEGORY: this.RESOURCE_PATH + "images/asset/evaluation_menu_info_category.svg",
            EVALUATION_MENU_DOC_PARTI: this.RESOURCE_PATH + "images/asset/evaluation_menu_participant.svg",
            EVALUATION_MENU_DOC_DATA: this.RESOURCE_PATH + "images/asset/evaluation_menu_data.svg",
            EVALUATION_MENU_DOC_COMMON: this.RESOURCE_PATH + "images/asset/evaluation_menu_common.svg",
            EVALUATION_MENU_DOC_SIGNATURE_BOOK: this.RESOURCE_PATH + "images/asset/evaluation_menu_signature_book.svg",
            EVALUATION_MENU_DOC_AGREEMENT: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator_agreement.svg",
            EVALUATION_MENU_DOC_QUESTION: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator_question.svg",
            EVALUATION_MENU_DOC_SURVEY: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator_survey.svg",
            EVALUATION_MENU_DOC_EVALUATION: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator_evaluate.svg",
            EVALUATION_MENU_DOC_EVALUATOR_LEADER: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator_evaluate.svg",
            EVALUATION_MENU_DOC_GATHERING: this.RESOURCE_PATH + "images/asset/evaluation_menu_gathering.svg",
            EVALUATION_MENU_DOC_RESULT: this.RESOURCE_PATH + "images/asset/evaluation_menu_result.svg",
            EVALUATION_MENU_EVALUATOR: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator.svg",
            EVALUATION_MENU_EVALUATEE: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluatee.svg",
            EVALUATION_MENU_SIGNATURE: this.RESOURCE_PATH + "images/asset/evaluation_menu_signature.svg",


            EVALUATION_MENU_READY_INFO: this.RESOURCE_PATH + "images/asset/evaluation_menu_info.svg",
            EVALUATION_MENU_READY_QUESTION: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator_question.svg",
            EVALUATION_MENU_READY_EVALUATION: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator_evaluate.svg",
            EVALUATION_MENU_READY_OUTPUT_FILE: this.RESOURCE_PATH + "images/asset/modal_convert.svg",

            EVALUATION_MENU_CLOSE_INFO: this.RESOURCE_PATH + "images/asset/evaluation_menu_info.svg",
            EVALUATION_MENU_CLOSE_EVALUATOR: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluator.svg",
            EVALUATION_MENU_CLOSE_EVALUATEE: this.RESOURCE_PATH + "images/asset/evaluation_menu_evaluatee.svg",

            ICON_MODAL_LOADING: this.RESOURCE_PATH + "images/asset/loading.svg",


            MODAL_ICON_LOADING: this.RESOURCE_PATH + "images/asset/loading.svg",
            MODAL_ICON_LOGOUT: this.RESOURCE_PATH + "images/asset/logout.svg",
            MODAL_ICON_CAUTION: this.CONTEXT_PATH + "images/asset/caution.svg",
            MODAL_ICON_LOADING_TRASH: this.RESOURCE_PATH + "images/asset/loading_trash.svg",
            MODAL_GATHERING: this.RESOURCE_PATH + "images/asset/modal_gathering.svg",
            MODAL_CONVERT: this.RESOURCE_PATH + "images/asset/modal_convert.svg",
            MODAL_EVALUATION_CLOSE: this.RESOURCE_PATH + "images/asset/modal_evaluation_close.svg",
            MODAL_EVALUATION_CLOSE_SUCCESS: this.RESOURCE_PATH + "images/asset/modal_evaluation_close_success.svg",

            NUM_1: this.RESOURCE_PATH + "images/asset/num1.svg",
            NUM_2: this.RESOURCE_PATH + "images/asset/num1.svg",
        };

        return image;
    };

    // cat. style
    get CONTAINER_STYLE() {
        return this._containerStyle;
    }

    // cat. token
    get IS_ENABLE_LOCALSTORAGE() {
        return this.isEnableLocalstorage;
    }

    set TOKEN_ACCESS(value) {
        this.appAccessToken = value;
    }

    get TOKEN_ACCESS() {
        return this.appAccessToken;
    }

    set TOKEN_REFRESH(value) {
        this.appRefreshToken = value;
    }

    get TOKEN_REFRESH() {
        return this.appRefreshToken;
    }

    set TOKEN_EVALUATOR_ACCESS(value) {
        this.evaluatorAccessToken = value;
    }

    get TOKEN_EVALUATOR_ACCESS() {
        return this.evaluatorAccessToken;
    }

    set TOKEN_EVALUATOR_REFRESH(value) {
        this.evaluatorRefreshToken = value;
    }

    get TOKEN_EVALUATOR_REFRESH() {
        return this.evaluatorRefreshToken;
    }

    set TOKEN_EVALUATEE_ACCESS(value) {
        this.evaluateeAccessToken = value;
    }

    get TOKEN_EVALUATEE_ACCESS() {
        return this.evaluateeAccessToken;
    }

    set TOKEN_EVALUATEE_REFRESH(value) {
        this.evaluateeRefreshToken = value;
    }

    get TOKEN_EVALUATEE_REFRESH() {
        return this.evaluateeRefreshToken;
    }


    //todo. delete

    get REST_API_UNIQUE_ID() {
        return {
            MINE: "mine",
            BFF: "bff",
            FILE: "file",
            COMPLETED: "completed",
            MEDIA_FILE: "media-file",
            RESOURCE_FILE: "resource-file",
            SIGNATURE_FILE: "signature-file",
            EVALUATOR_DATA: "evaluator-data",
        }
    };
}

const OptionSingleton = (() => {
    let instance = null;
    return {
        getInstance: function () {
            if (!instance) {
                instance = new Option()
            }
            return instance;
        }
    }
})();

export default OptionSingleton.getInstance();